/* Roadhouse Merkliste: remembered pieces, stored in the visitor's browser (no app, no account).
 *
 * Buttons: any element with [data-rh-wish] and data-handle/-title/-url/-image/-price/-vendor
 * toggles the piece. [data-rh-wish-label] inside shows "Merken"/"Gemerkt".
 * Counter: [data-rh-wish-count] shows the number of pieces (hidden at 0).
 * The page section rh-wishlist reads the list through window.RhWishlist.
 *
 * The old wishlist (OnHOW code) used two different storage keys; both are merged once. */
(() => {
  'use strict';
  const KEY = 'rh-wishlist';
  const OLD_KEYS = ['onhow-wishlist', 'onhow_wishlist'];

  const handleFromUrl = (url) => {
    const m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  };
  const parse = (raw) => { try { const v = JSON.parse(raw || 'null'); return Array.isArray(v) ? v : null; } catch { return null; } };
  const normalize = (it) => {
    const handle = it.handle || handleFromUrl(it.url);
    if (!handle) return null;
    return { handle, title: String(it.title || ''), url: it.url || `/products/${handle}`, image: it.image || '', price: String(it.price || ''), vendor: String(it.vendor || ''), added: it.added || Date.now() };
  };

  function read() {
    let list = null;
    try { list = parse(localStorage.getItem(KEY)); } catch { return []; }
    if (list) return list;
    // first visit with the new code: take over what the old wishlist stored
    const merged = [];
    try {
      OLD_KEYS.forEach((k) => (parse(localStorage.getItem(k)) || []).forEach((it) => {
        const n = normalize(it);
        if (n && !merged.some((m) => m.handle === n.handle)) merged.push(n);
      }));
      localStorage.setItem(KEY, JSON.stringify(merged));
    } catch { /* storage blocked: start empty */ }
    return merged;
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* storage blocked */ }
    render();
    document.dispatchEvent(new CustomEvent('rh:wishlist', { detail: { list } }));
  }
  const has = (handle) => read().some((it) => it.handle === handle);
  function toggle(data) {
    const list = read();
    const i = list.findIndex((it) => it.handle === data.handle);
    if (i >= 0) list.splice(i, 1);
    else { const n = normalize(data); if (n) list.unshift(n); }
    write(list);
    return i < 0;
  }
  const remove = (handle) => write(read().filter((it) => it.handle !== handle));

  function render() {
    const list = read();
    const set = new Set(list.map((it) => it.handle));
    document.querySelectorAll('[data-rh-wish]').forEach((btn) => {
      const on = set.has(btn.dataset.handle);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      const title = btn.dataset.title || '';
      btn.setAttribute('aria-label', on ? `${title} von der Merkliste nehmen` : `${title} merken`);
      const label = btn.querySelector('[data-rh-wish-label]');
      if (label) label.textContent = on ? 'Gemerkt' : 'Merken';
    });
    document.querySelectorAll('[data-rh-wish-count]').forEach((el) => {
      el.textContent = String(list.length);
      el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-rh-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const added = toggle({ ...btn.dataset });
    btn.classList.remove('is-pop');
    void btn.offsetWidth; // restart the short confirmation
    if (added) btn.classList.add('is-pop');
    const live = document.getElementById('rh-wish-live');
    if (live) live.textContent = added ? `${btn.dataset.title} gemerkt.` : `${btn.dataset.title} von der Merkliste genommen.`;
  });

  // other tabs, and product grids that are re-rendered by filters or search
  window.addEventListener('storage', (e) => { if (e.key === KEY) render(); });
  let t = 0;
  new MutationObserver((records) => {
    if (records.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.('[data-rh-wish]') || n.querySelector?.('[data-rh-wish]'))))) {
      clearTimeout(t); t = setTimeout(render, 30);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  const live = document.createElement('div');
  live.id = 'rh-wish-live';
  live.setAttribute('aria-live', 'polite');
  live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
  const boot = () => { if (!document.getElementById('rh-wish-live')) document.body.appendChild(live); render(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.RhWishlist = { read, write, has, toggle, remove, render };
})();
